const ConditionalWrapper = ({ condition, wrapperIf, wrapperElse, children }) =>
  condition
    ? wrapperIf(children)
    : wrapperElse
      ? wrapperElse(children)
      : children;

export default ConditionalWrapper;
